import React, { useContext, useState, useMemo, useRef } from 'react';

import { PlaylistWrapperVScroll } from 'components/Playlist/PlaylistUI';
import { sortDocuments } from 'utils/NwUtils';
import useDimensions from 'hooks/UseDimensions';
import { ConfigContext } from 'contexts/ConfigContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { BookLayoutContext } from 'contexts/BookLayoutContext';
import { usePackage } from 'contexts/PackageContext';
import { Popover } from 'antd';


const PlaylistVScroll = ({
    modelFileName,
    playlist,
    isActive
}) => {
    const dimensions = useDimensions();
    const { clientConfig } = useContext(ConfigContext)
    const { playlistTemplates, playlistViewer, exportOptions } = clientConfig
    const { packageCode } = usePackage();

    const [page, setPage] = useState(0)

    const { siderOpen, siderAsDrawer, siderWidth } = useContext(BookLayoutContext);

    const heightToSubtract = 250
    const widthToSubtract = (siderOpen && !siderAsDrawer) ? (siderWidth + 180) : 200;

    const wrapper = useRef(null);

    const isOnlyVideos = () => {
        if (playlist) {
            if (playlist.DocumentPlaylists.length > 0) {
                return playlist.DocumentPlaylists.every(document => document.Type === 'Video')
            }
        }
        return false
    }

    const documentsPerPages = useMemo(() => {
        let documentsPerPages = [{ wide: false, documents: [] }]; //{ wide: false, documents: []}
        let index = 0, page = 0;
        if (playlist) {
            const documentPlaylists = sortDocuments(playlist.DocumentPlaylists);
            while (index < documentPlaylists.length) {
                if (documentPlaylists[index].Type === 'Video' || documentPlaylists[index].Standard.Width >= documentPlaylists[index].Standard.Height || (index === 0 && documentPlaylists[index].DocumentOrder === 1)) {
                    if (index === 0) {
                        documentsPerPages[page].documents.push(documentPlaylists[index])
                        documentsPerPages[page].wide = true
                    } else {
                        documentsPerPages.push({ wide: true, documents: [documentPlaylists[index]] })
                        page += 1
                    }
                } else {
                    if (documentsPerPages[page]) {
                        if (documentsPerPages[page].wide || documentsPerPages[page].documents.length === 2 || (index > 0 && documentPlaylists[index].DocumentOrder > (documentPlaylists[index - 1].DocumentOrder + 1))) {
                            //|| (page === 0 && documentsPerPages[page].documents.length === 1))
                            documentsPerPages.push({ wide: false, documents: [documentPlaylists[index]] })
                            page += 1
                        } else {
                            documentsPerPages[page].documents.push(documentPlaylists[index])
                        }
                    } else {
                        documentsPerPages.push({ wide: false, documents: [documentPlaylists[index]] })
                        page += 1
                    }
                }
                index += 1;
            }
        }

        return documentsPerPages;
    }, [playlist])

    // useEffect(() => {
    //     if (isActive) {
    //         window.addEventListener('keydown', handleKeyDown);
    //         return function cleanup() {
    //             window.removeEventListener('keydown', handleKeyDown);
    //         };
    //     } else {
    //         window.removeEventListener('keydown', handleKeyDown);
    //     }
    // }, [page, documentsPerPages, isActive]);


    // const handleKeyDown = event => {
    //     if (event.keyCode === ARROW_LEFT_KEYCODE) {
    //         onMoveToPrev();
    //     } else if (event.keyCode === ARROW_RIGHT_KEYCODE) {
    //         onMoveToNext();
    //     }
    // };

    const printPlaylist = (template) => {
        const isCustomTemplate = template.isCustom ? 'true' : 'false';
        let url = '/api/packages/printplaylist?';
        url += 'PackagePlaylistID=' + playlist.ID;
        url += '&PackageCode=' + packageCode;
        url += '&Template=' + template.file;
        url += '&IsCustom=' + isCustomTemplate;
        url += '&Orientation=' + template.orientation;
        window.open(url, '_blank');
    }

    const downloadPlaylist = () => {
        let url = '/api/packages/downloadplaylist?';
        url += 'PackagePlaylistID=' + playlist.ID;
        url += '&PackageCode=' + packageCode;
        window.open(url, '_blank');
    }

    const TemplateChooser = () => (
        <div className="template-chooser-popover">
            <ul>
                {playlistTemplates.map((template, index) => (
                    <li key={template.name} className="print-option" onClick={() => printPlaylist(template)}>
                        {template.name}
                    </li>
                ))}
            </ul>
        </div>
    )



    let boxHeight = dimensions.Height > 0 ? dimensions.Height - heightToSubtract : 0;
    boxHeight = boxHeight > 1160 ? 1160 : boxHeight < 450 ? 450 : boxHeight;
    let boxWidth = dimensions.Width - widthToSubtract;

    const getImageRatioForWidth = () => {
        let ratiodecimal = 1.25
        if (playlistViewer.imageRatio) {
            ratiodecimal = parseFloat(playlistViewer.imageRatio) / 100
        }
        return 1 / ratiodecimal
    }

    const getWidthForWide = () => {
        return (getImageRatioForWidth() * 2 * boxHeight)
    }

    const BookRow = ({ page, index }) => {
        if (page.wide) {
            return (
                <div className="book-row-wide">
                    <div className="book-page">
                        <img alt="" src={page.documents[0].Standard.Url} />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="book-row">
                    {page.documents.map((document, index) => (
                        <div className="book-page" key={index} style={{backgroundImage: `url(${document.Standard.Url})`}}>
                            &nbsp;
                        </div>
                    ))}
                </div>
            )
        }
        // (document.Type === 'Video'
        //     ?
        //     <VideoPlayer
        //         //defaultPlay
        //         //style={{ width: boxWidth }}
        //         document={document} />
        //     :
        //     <div className="book-row-picture">
        //         <img alt="" src={`${GetDocumentCover(document)}`} />
        //     </div>
        // )
    }

    return (
        <PlaylistWrapperVScroll
            ref={wrapper}
            $imageRatioForWidth={getImageRatioForWidth()}
            $widthForWide={getWidthForWide()}
            $boxWidth={boxWidth}
            $boxHeight={boxHeight}
            $imageGutter={playlistViewer.imageGutter}
        >
            <div className="model-wrapper">
                <div className="book-container">
                    <section className="model-playlist-tools">
                        <div className='page-counter'>{`${page + 1}/${documentsPerPages.length}`}</div>
                        {!isOnlyVideos() && exportOptions.pdfPlaylist && (
                            <div className='print-button'>
                                {playlistTemplates && playlistTemplates.length > 0 &&
                                    (playlistTemplates.length === 1
                                        ?
                                        <FontAwesomeIcon onClick={() => printPlaylist(playlistTemplates[0])} icon={light("file-pdf")} />
                                        :
                                        <Popover content={<TemplateChooser />} placement="left" title="Print Book" trigger="hover">
                                            <FontAwesomeIcon icon={light("file-pdf")} />
                                        </Popover>
                                    )
                                }
                            </div>
                        )}
                        {exportOptions.zipDownload && (
                            <div className='download-button'>
                            <FontAwesomeIcon onClick={downloadPlaylist} icon={light("cloud-arrow-down")} />
                            </div>
                        )}
                    </section>
                    <div className="book-viewer">
                        {documentsPerPages.map((page, index) => (
                            <BookRow key={index} page={page} index={index} />
                        ))}
                    </div>
                </div>
            </div>
        </PlaylistWrapperVScroll>
    )
};

export default PlaylistVScroll;
